const Event = {

    // BUTTON
    "details": "विवरण देखें",

    // PAGE HEADER
    "tagline": "इवेंट्स जो हमें एक साथ लाते हैं",

    // FIELDS
    "category": "श्रेणी",
    "date": "तिथि",
    "city": "शहर",

}

export default Event;